import { IconButton } from 'material-ui';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import * as React from 'react';
import { FileModel } from '../../../../models';
import { Views } from '../../../abstract';


interface IProjectAddEditViewGalleryImageCardProps {
    image: FileModel
    index: number
    languageTabValue: string
    onDeleteGalleryImageFromStack: (index: number) => void
    onTextChange: (e: any, n: string, i: number) => void
}

class ProjectAddEditViewGalleryImageCard extends React.Component<IProjectAddEditViewGalleryImageCardProps> {
    public render() {
        const { index, image, languageTabValue, onDeleteGalleryImageFromStack, onTextChange } = this.props;
        return (
            <React.Fragment key={index}>
                <div className="dropzone-image">
                    <img style={{width: '100%', borderRadius: 10 }} src={image[languageTabValue]?image[languageTabValue].url() ? image[languageTabValue].url() : image[languageTabValue]._source.file.preview : null} />
                    <IconButton className="dropzone-remove-image">
                        <CloseIcon
                            onClick={()=>onDeleteGalleryImageFromStack(index)}
                            color="#fff"
                        />
                    </IconButton>
                </div>
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="gallery alt"
                    style={{marginBottom:35}}
                    value={image['alt'][languageTabValue] || ''}
                    onChange={(e) => onTextChange(e, '', index)}
                />
            </React.Fragment>
        ) as any
    }
}

export default ProjectAddEditViewGalleryImageCard





// WEBPACK FOOTER //
// ./src/app/dashboard/project/addedit/ProjectAddEditViewGalleryImageCard.tsx